import { render, staticRenderFns } from "./ChannelForm.vue?vue&type=template&id=796385c9&scoped=true&"
import script from "./ChannelForm.vue?vue&type=script&lang=js&"
export * from "./ChannelForm.vue?vue&type=script&lang=js&"
import style0 from "./ChannelForm.vue?vue&type=style&index=0&id=796385c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796385c9",
  null
  
)

export default component.exports